import { Box, Grid, Typography } from "@mui/material";
import { HashLink as Link } from "react-router-hash-link";
import Section from "../components/Section";
import SubTitleHeader from "../components/SubTitle";

export const textDecoration = {
  textDecorationColor: "#f1dd84",
  textDecoration: "none",
};

export const linkStyles = { color: "yellow.main" };

const GetInvolvedScreen = () => {
  return (
    <Box>
      <Section title="Get Involved">
        <Grid item xs={12}>
          <SubTitleHeader subTitle="General Info" />
        </Grid>
        <Typography
          sx={{
            fontSize: 16,
            marginBottom: "8px",
          }}
          color="primary"
        >
          We're creating Amplitude to bring together a wide spectrum of individuals with an even wider variety
          of skills, passions, and creative outlets. We need your help to make this next itteration our best one yet.
        </Typography>

        <SubTitleHeader subTitle="Choose a way to get involved…" />
        <Grid sx={{ marginBottom: "10px" }}>
        <Link to={"#Volunteer"} style={textDecoration}>
            <Typography sx={linkStyles}>Volunteer</Typography>
          </Link>
          <Link to={"#DJ"} style={textDecoration}>
            <Typography sx={linkStyles}>DJ</Typography>
          </Link>
          <Link to={"#Art"} style={textDecoration}>
            <Typography sx={linkStyles}>Bring Art</Typography>
          </Link>
          <Link to={"#Activity"} style={textDecoration}>
            <Typography sx={linkStyles}>Lead an Activity</Typography>
          </Link>
          <Link to={"#FirstAid"} style={textDecoration}>
            <Typography sx={linkStyles}>First Aid</Typography>
          </Link>
        </Grid>
      </Section>
      <Section>
        <Grid container>
          <Grid item xs={12}>
            <SubTitleHeader anchor="Volunteer" subTitle="Volunteer" />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginBottom: "20px",
              paddingBottom: "20px",
              borderBottom: 2,
              borderColor: "teal.dark",
            }}
          >
            <Typography
              sx={{
                fontSize: 16,
                marginBottom: "8px",
              }}
              color="primary"
            >
              The central area of our campground is where we will have all of our programming, and we're planning to setup shade, benches, and other infrastructure items to help the space feel like a community hub. We'll need help setting up infrastructure pre-event and tearing it down post-event. If you want to chip in fill out the application below.
              <br />
              <br />
              <a href="https://lith.io/amplitude-2026-volunteer" target="_blank" rel="noopener noreferrer">Amplitude Festival 2026 Volunteer Application</a>
            </Typography>
          </Grid>
        </Grid>
      </Section>
      <Section>
        <Grid container>
          <Grid item xs={12}>
            <SubTitleHeader anchor="DJ" subTitle="DJ" />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginBottom: "20px",
              paddingBottom: "20px",
              borderBottom: 2,
              borderColor: "teal.dark",
            }}
          >
            <Typography
              sx={{
                fontSize: 16,
                marginBottom: "8px",
              }}
              color="primary"
            >
              We know we have so many talented DJs in our extended community, and can't wait to provide a world-class production that will elevate so many of their sets. We're looking for submissions from a diverse range of genres, so please feel free to submit a mix for a genre that you are most comfortable DJing, a genre you feel would be a great addition to an end of season festival, or a genre you know you'll really enjoy playing! Mixes submitted should have some examples of the genre(s) you want to play.
              <br />
              <br />
              <a href="https://lith.io/amplitude-2026-djs" target="_blank" rel="noopener noreferrer">Amplitude Festival 2026 DJ Submission Form</a>
            </Typography>
          </Grid>
        </Grid>
      </Section>
      <Section>
        <Grid container>
          <Grid item xs={12}>
            <SubTitleHeader anchor="Art" subTitle="Bring Art" />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginBottom: "20px",
              paddingBottom: "20px",
              borderBottom: 2,
              borderColor: "teal.dark",
            }}
          >
            <Typography
              sx={{
                fontSize: 16,
                marginBottom: "8px",
              }}
              color="primary"
            >
              The central area of our campground is where we will have all of our programming, and we would love to accentuate the space with art installations. Want to add to the visual or tactile landscape? Apply to bring art!
              <br />
              <br />
              <a href="https://lith.io/amplitude-2026-art" target="_blank" rel="noopener noreferrer">Amplitude Festival 2026 Art Installation Application</a>
            </Typography>
          </Grid>
        </Grid>
      </Section>
      <Section>
        <Grid container>
          <Grid item xs={12}>
            <SubTitleHeader anchor="Activity" subTitle="Lead an Activity" />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginBottom: "20px",
              paddingBottom: "20px",
              borderBottom: 2,
              borderColor: "teal.dark",
            }}
          >
            <Typography
              sx={{
                fontSize: 16,
                marginBottom: "8px",
              }}
              color="primary"
            >
              The central area of our campground is where we will have all of our programming, and we would love to add to that community hub with ongoing programming throughout the Saturday of the festival. Have an activity or workshop you'd like to lead? Submit an application below! 
              <br />
              <br />
              <a href="https://lith.io/amplitude-2026-activity" target="_blank" rel="noopener noreferrer">Amplitude Festival 2026 Activity Leader Application</a>
            </Typography>
          </Grid>
        </Grid>
      </Section>
      <Section>
        <Grid container>
          <Grid item xs={12}>
            <SubTitleHeader anchor="FirstAid" subTitle="First Aid" />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginBottom: "20px",
              paddingBottom: "20px",
              borderBottom: 2,
              borderColor: "teal.dark",
            }}
          >
            <Typography
              sx={{
                fontSize: 16,
                marginBottom: "8px",
              }}
              color="primary"
            >
              Applications to join the First Aid team will open in the coming weeks.
              <br />
              <br />
            </Typography>
          </Grid>
        </Grid>
      </Section>
    </Box>
  );
};

export default GetInvolvedScreen;
